<template>
<div class="chapter">
<div class="inner_page">
<a id="page_1"></a>
<p class="half"><span class="bold">THE LIVERPOOL AND MANCHESTER RAILWAY</span></p>
<a id="page_2"></a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 01_Halftitle.vue?04b86800